module.exports = __webpack_public_path__ + "static/afcc-fb6a70c9df2684c83c3951ea87fcc9cb.png";